import { useRouter } from 'next/router';
import { enqueueSnackbar } from 'notistack';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { ProfileModal } from '@/Module/Auth/Component';
import type { ICompleteProfileForm } from '@/Module/Auth/Model/DataModel';
import { authUpdatePersonAction } from '@/Module/Auth/Store/Action';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const WAITING_TIME = 8; // 8 seconds
const SHOULD_HIDE = (pathname: string) => pathname.includes('auth') || pathname.includes('subscription');
const CompleteProfileModal: FC = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const person = useAppSelector(state => state.auth.person)!;
  const loggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const profileCompleted = person?.isComplete;
  const [modalOpen, setModalOpen] = useState(false);
  const handleProfileSuccess = async (payload: ICompleteProfileForm) => {
    const updatedPerson = await dispatch(authUpdatePersonAction({
      id: person.id,
      fundametalId: person.fundametalId,
      gender: person.gender,
      name: payload.firstName,
      family: payload.lastName,
      gradeId: payload.grad.value,
      fieldId: payload.field?.value || 17,
      birthDate: payload.birthDate!,
      stateId: payload.province?.value,
      cityId: payload.city?.value
    })).unwrap();
    if (updatedPerson?.activatedFreemium) enqueueSnackbar({
      variant: 'success',
      message: 'به پاس تکمیل اطلاعات کاربری، اشتراک رایگان به شما اختصاص یافت!',
      autoHideDuration: WAITING_TIME * 1000
    });
  };
  useEffect(() => {
    if (loggedIn && !profileCompleted) setModalOpen(true);
  }, [loggedIn, profileCompleted]);
  if (!loggedIn || profileCompleted || SHOULD_HIDE(router.pathname)) return null;
  return <ProfileModal isOpen={modalOpen} onSuccess={handleProfileSuccess} data-sentry-element="ProfileModal" data-sentry-component="CompleteProfileModal" data-sentry-source-file="CompleteProfileModal.tsx" />;
};
export default CompleteProfileModal;